module.exports = __webpack_public_path__ + "img/partner.c7b11b04.jpg";